<template>
  <a
    :href="ejusticeUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center space-x-2 py-2 duration-200"
  >
    <img
      :src="faviconUrl"
      alt="E-Justice favicon"
      class="w-6 h-6 rounded mr-8"
      @error="fallbackFavicon"
    />
    <span class="text-black-600 text-sm hover:text-blue-800 transition-transform duration-200 hover:scale-105 flex items-center">
      {{ $gettext("Page E-Justice") }}
    </span>
  </a>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
  enterpriseNumber: { type: String, required: true }
});

const cleanedEnterpriseNumber = computed(() =>
  props.enterpriseNumber.replace(/\D/g, "")
);

const ejusticeUrl = computed(() =>
  `https://www.ejustice.just.fgov.be/cgi_tsv/list.pl?language=fr&btw=${cleanedEnterpriseNumber.value}&page=1&view_numac=${cleanedEnterpriseNumber.value}#SUM`
);

const faviconUrl = ref("https://www.ejustice.just.fgov.be/favicon.ico");

function fallbackFavicon(event) {
  event.target.src = "https://www.google.com/s2/favicons?domain=www.ejustice.just.fgov.be";
}
</script>
